import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_RELAZIONE_TIPO } from '../../data.const';
import {
  retrieveRelazioneTipoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteRelazioneTipoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_RELAZIONE_TIPO),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ anagraficaLoader: true })),
        defer(() =>
          from(
            request({
              path: `relazioneTipo`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            switchMap(() => of(retrieveRelazioneTipoListAction(null))),
            catchError(err => {
              console.error(`[epic ${DELETE_RELAZIONE_TIPO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ anagraficaLoader: false }))
      );
    })
  );

export default deleteRelazioneTipoEpic;
